<template>
  <div v-if="$route.query.serviceID" class="modal-wrap">
    {{ getServiceData() }}
    <div class="service-modal-bg" v-if="serviceData && serviceData.gotUserData"></div>
    <div v-if="serviceData && serviceData.gotUserData" class="service-modal-container">
      <button class="service-modal-container__close-btn" @click="() => {
        $router.push(`${$route.path}`).then(() => serviceData = null)
      }"><img src="@/assets/icons/x-white.svg" alt=""></button>

      <div class="service-modal-container__img" :style="{ 'background-image': 'url(' + this.serviceData.photo_url + ')' }"></div>

      <div class="service-modal-container__conent">
        <div class="service-modal-container__conent__top">
          <div v-if="currentUser && $route.path !== '/profile/fav-services'">
            <button v-if="currentUser.role_id == 3" class="service-modal-container__conent__top__fav-btn" @click="setFav()">
              <img src="@/assets/icons/heart.svg" alt="dodaj do ulubionych">
            </button>
          </div>

          <div class="service-modal-container__conent__top__heading">
            <h3>{{ serviceData.name }}</h3>
            <router-link :to="`/browse/user/${serviceData.gotUserData.id}`">{{ serviceData.gotUserData.name }}</router-link>
          </div>

          <span class="service-modal-container__conent__top__price">{{ serviceData.price }} zł</span>

          <div class="service-modal-container__conent__top__actions">
            <button
                v-if="!noScheduleBtn"
                class="service-modal-container__conent__top__btn"
                :style="serviceData.advanceAmount ? 'margin-top: 20px' : null"
                @click="() => $router.push({path: '/profile/make-appointment', query: {serviceid: serviceData.id}})"
            >
              Umów wizytę
            </button>
            <span v-if="serviceData.advanceAmount" class="advance-info">Zaliczka <img src="@/assets/icons/cash.svg" alt="">{{ serviceData.advanceAmount }}%</span>
          </div>
        </div>

        <div class="service-modal-container__conent__bottom">
          <div class="service-modal-container__conent__bottom__left">
            <span>{{ serviceData.gotUserData.category.name }}</span>
            <span>{{ serviceData.address }}</span>
            <span>{{ serviceData.phone }}</span>
            <span class="employee" v-if="serviceData.gotEmployeeData" @click="() => $router.push(`/browse/user/${serviceData.gotEmployeeData.id}`)">
              <img src="@/assets/icons/person-fill.svg" alt="">
              {{ serviceData.gotEmployeeData.firstname }} {{ serviceData.gotEmployeeData.lastname }}
            </span>
            <span class="report" @click="() => report()">zgłoś</span>
          </div>

          <div class="service-modal-container__conent__bottom__center"></div>

          <div class="service-modal-container__conent__bottom__right">
            <p>{{ serviceData.short_description }}</p>
            <p class="desc" v-html="serviceData.description.replace(/\n/g, '<br>')"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import authHeader from '@/services/auth-header';
import axios from 'axios';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';

export default{
  name:'ServiceModal',
  setup() {
    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    }
  },
  data(){
    return{
      serviceData: null
    }
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    }
  },
  props:['noScheduleBtn'],
  methods:{
    getServiceData(){
      if(!this.serviceData){
        axios.get(`/Service/${this.$route.query.serviceID}`).then(res => {
          this.serviceData = res.data
          if(this.serviceData){
            axios.get(`/User/${res.data.user_id}`).then(resp => {
              this.serviceData.gotUserData = resp.data
            }).catch(() => {})

            axios.get(`/User/${res.data.employee_id}`).then(resp => {
              this.serviceData.gotEmployeeData = resp.data
            }).catch(() => {})
          }else{
            this.appStore.setIsAlert('nie ma już takiej usługi')
          }
        })
      }
    },
    report(){
      const route = this.$router.resolve({path: '/report', query: {label: `usługę: ${this.serviceData.name}`, id: this.serviceData.id, property: 'service_id'}})
      window.open(route.href, '_blank')
    },
    setFav(){
      axios.post('/UserService', {
        user_id: this.currentUser.id,
        service_id: this.$route.query.serviceID
      }, authHeader()).then(() => {
        this.appStore.setIsSuccess('Dodano do ulubionych. Usługę znajdziesz w panelu konta')
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.service-modal-bg{
  position: fixed;
  width: 100vw;
  height: calc(100vh + 10px);
  background-color: rgba(17, 24, 39, .78);
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  backdrop-filter: blur(2px);
}

.service-modal-container{
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: min(1100px, calc(100% - 24px));
  background-color: #fff;
  border-radius: 14px;
  border: 1px solid #e5e7eb;
  z-index: 1100;
  overflow: hidden;
  max-height: 90vh;
  box-shadow: 0 20px 45px rgba(0,0,0,.3);

  &::-webkit-scrollbar{ width: 8px; }
  &::-webkit-scrollbar-track { background: #fff; }
  &::-webkit-scrollbar-thumb {
    background: #9ca3af;
    border-radius: 999px;
  }

  &__img{
    width: 100%;
    height: 230px;
    background-position: center;
    background-size: cover;
  }

  &__close-btn{
    position: absolute;
    top: 12px;
    right: 12px;
    border: none;
    border-radius: 50%;
    background-color: #111827;
    width: 36px;
    height: 36px;
    cursor: pointer;
    z-index: 2;
    img{
      transform: translate(-4px, 2px);
      width: 30px;
      height: 30px;
    }
  }

  &__conent{
    display: flex;
    flex-direction: column;
    gap: 18px;
    padding: 20px;

    &__top{
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      flex-wrap: wrap;
      border-bottom: 1px solid #e5e7eb;
      padding-bottom: 16px;

      &__heading{
        display: flex;
        flex-direction: column;
        gap: 5px;
        min-width: 220px;
        h3{
          margin: 0;
          color: #111827;
        }
        a{
          color: #059669;
          text-decoration: none;
          font-weight: 600;
        }
        a:hover{
          text-decoration: underline;
        }
      }

      &__price{
        padding: 10px 16px;
        background-color: #ecfdf5;
        border: 1px solid #10b981;
        color: #065f46;
        border-radius: 10px;
        font-weight: 700;
      }

      &__btn{
        padding: 10px 14px;
        background-color: #10b981;
        color: #fff;
        border-radius: 8px;
        border: none;
        cursor: pointer;
        font-weight: 700;
      }
      &__btn:hover{
        background: #059669;
      }

      &__fav-btn{
        background: #f3f4f6;
        border: 1px solid #d1d5db;
        border-radius: 8px;
        width: 34px;
        height: 34px;
        cursor: pointer;
      }

      &__actions{
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      }
    }

    &__bottom{
      display: flex;
      justify-content: space-between;
      gap: 16px;
      max-height: 40vh;
      overflow-y: auto;
      padding-right: 6px;

      &::-webkit-scrollbar{ width: 8px; }
      &::-webkit-scrollbar-track { background: #fff; }
      &::-webkit-scrollbar-thumb {
        background: #9ca3af;
        border-radius: 999px;
      }

      &__left{
        display: flex;
        flex-direction: column;
        gap: 12px;
        width: 250px;
        font-size: 1.6rem;
        align-items: flex-end;
        text-align: right;
        color: #374151;

        .employee{
          cursor: pointer;
          text-decoration: underline;
          display: inline-flex;
          align-items: center;
          gap: 6px;
        }
        .report{
          color: #dc2626;
          cursor: pointer;
          font-weight: 600;
        }
      }

      &__center{
        width: 1px;
        background-color: #e5e7eb;
      }

      &__right{
        width: calc(100% - 270px);
        min-width: 250px;
        color: #1f2937;
        .desc{
          font-size: 1.6rem;
          line-height: 1.55;
        }
      }
    }
  }
}

.advance-info{
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  color: #374151;
  img{
    width: 18px;
  }
}

@media (max-width: 900px){
  .service-modal-container{
    &__conent{
      &__top{
        &__actions{
          align-items: flex-start;
        }
      }
      &__bottom{
        flex-direction: column;
        max-height: 45vh;
        &__center{
          display: none;
        }
        &__left{
          width: 100%;
          align-items: flex-start;
          text-align: left;
          border-bottom: 1px dashed #d1d5db;
          padding-bottom: 12px;
        }
        &__right{
          width: 100%;
          min-width: 0;
        }
      }
    }
  }
}
</style>